<div class="modal-header">
  <h4 class="modal-title">{{title | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form [formGroup]="form">
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label">{{'editDescriptionPopup.label.description' | translate}}:</label>
        <div class="col-md-8">
          <input class="form-control" type="text"
            formControlName="description"
            [class.is-invalid]="form.controls.description.invalid"
            appInputAutoFocus autofocus
            (keydown.enter)="accept()">
          <div class="invalid-feedback">
            {{ form.controls.description.errors?.messageKey | translate:{'0':form.controls.description.errors?.param} }}
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.cancel' | translate}}</button>
  <button type="submit" class="btn btn-primary btn-forward" (click)="accept()" [disabled]="form.invalid">{{'global.label.accept' | translate}}</button>
</div>
